import React, { useState } from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { surveyCopyService } from '../../../services/survey-copy.service';

interface SurveyExportButtonProps {
  surveyId: string;
  surveyName: string;
}

export const SurveyExportButton: React.FC<SurveyExportButtonProps> = ({ surveyId, surveyName }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    try {
      setLoading(true);
      const payload = await surveyCopyService.exportSurvey(surveyId);
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${surveyName || 'survey'}-export.json`;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
      message.success('Pesquisa exportada com sucesso');
    } catch (error: any) {
      message.error(error?.response?.data?.message || 'Falha ao exportar pesquisa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button icon={<DownloadOutlined />} loading={loading} onClick={handleExport}>
      Exportar JSON
    </Button>
  );
};
